import * as React from "react";
import { CircleNotch } from "@/components/ui/icons";
import { cn } from "@/lib/utils";

interface SpinnerProps {
  size?: number;
  className?: string;
}

/**
 * Spinner - GPU-accelerated loading spinner
 *
 * Wraps the SVG icon in a div to enable hardware acceleration for CSS animations.
 * This provides smoother animations, especially on mobile devices.
 *
 * @see https://agentskills.io - Vercel React Best Practices (Rule 6.1)
 *
 * Usage:
 * ```tsx
 * <Spinner size={16} />
 * <Spinner size={32} className="text-primary" />
 * ```
 */
export function Spinner({ size = 16, className }: SpinnerProps) {
  return (
    <div
      className={cn("animate-spin", className)}
      style={{ width: size, height: size }}
    >
      <CircleNotch size={size} weight="bold" />
    </div>
  );
}
